export default __webpack_public_path__ + "static/media/ketodrink@3x.c30077a0.jpg";